import { render, staticRenderFns } from "./teamNull.vue?vue&type=template&id=963d946c&scoped=true&"
import script from "./teamNull.vue?vue&type=script&lang=js&"
export * from "./teamNull.vue?vue&type=script&lang=js&"
import style0 from "./teamNull.vue?vue&type=style&index=0&id=963d946c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "963d946c",
  null
  
)

export default component.exports